import styled, { css, keyframes } from 'styled-components'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

const tooltipFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const tooltipFadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(4px);
  }
`

export const Styles = {
  StylesContainer: styled(Container)`
    padding: 24px 16px 0;
    display: flex;
    flex-direction: column;
    height: fit-content;
    color: ${COLORS.BLACK};
  `,

  Title: styled.p`
    font-size: 30px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
    margin-bottom: 24px;
  `,

  Subtitle: styled.p`
    font-size: 17px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 24px;
  `,

  DownloadOption: styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-start;

    & + & {
      margin-top: 16px;
    }
  `,

  OptionNumber: styled.div`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f2f3f5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    line-height: 24px;
  `,

  OptionText: styled.p`
    font-size: 15px;
    line-height: 20px;

    & button {
      background-color: transparent;
      border: none;
      padding: 0;
      color: ${({ theme }) => theme.colors.strongTextColor};
      font-size: 15px;
      font-weight: 700;
      line-height: 20px;
      cursor: pointer;
    }

    strong {
      font-weight: 600;
    }

    b {
      font-weight: 700;
    }
  `,

  ImageWrapper: styled.div`
    min-height: 615px;
    margin: 26px 0;
  `,

  Image: styled.img`
    width: 100%;
    height: 100%;
  `,

  LoggedInWrapper: styled.div`
    padding: 16px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgb(232, 232, 232) 0px 8px 20px 0px;
  `,

  LoggedInTitle: styled.p`
    font-size: 17px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
  `,

  CopyEmail: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-radius: 16px;
    border: 1px solid #d3d3d3;
    background: #fff;
    margin: 16px 0;
  `,

  UserEmail: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  `,

  EmailLabel: styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #7c8899;
  `,

  EmailInput: styled.input`
    width: 100%;
    border: none;
    outline: none;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    background: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,

  CopyButtonWrapper: styled.div`
    position: relative;
    flex-shrink: 0;
  `,

  CopyButton: styled.button`
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7c8899;
  `,

  CopiedTooltip: styled.div<{ $isVisible: boolean }>`
    position: absolute;
    color: ${COLORS.WHITE};
    bottom: calc(100% + 10px);
    inset-inline-end: -4px;
    background: ${COLORS.BLACK};
    border-radius: 12px;
    padding: 10px 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    z-index: 10;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    pointer-events: none;

    ${({ $isVisible }) =>
      $isVisible
        ? css`
            animation: ${tooltipFadeIn} 0.2s ease forwards;
          `
        : css`
            animation: ${tooltipFadeOut} 0.2s ease forwards;
          `}/* &::after {
      content: '';
      position: absolute;
      bottom: -6px;
      right: 8px;
      width: 12px;
      height: 6px;
      background: ${COLORS.BLACK};
      clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
    } */
  `,

  CopiedTooltipIcon: styled.span`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #4f45e4;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &::after {
      content: '';
      width: 11px;
      height: 7px;
      border-left: 2px solid #fff;
      border-bottom: 2px solid #fff;
      transform: rotate(-45deg) translateY(-1px);
    }
  `,

  SupportLink: styled.a`
    color: #4f45e4;
    text-decoration: underline;
    cursor: pointer;
  `,

  StyledButton: styled(Button)``,
} as const
